/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const GET_JBP_DASHBOARD_SUMMARY_STAT = gql`
  query GetJBPDashboardSummaryStat($input: JBPReportInput!) {
    jbpDashboardSummaryStat(input: $input) {
      label
      value
      valueType
      totalValue
      previousValue
      previousTotalValue
      percentChange
      percentShareLabels {
        primary
        secondary
      }
    }
  }
`
